import { useState } from 'react'
import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { PointsImageEditor } from '../components/PointsImageEditor'
import { Button } from '@/ui/atoms/button/Button'

interface PointsImageEditorViewProps {
  points: number
  rank: number
}

export function PointsImageEditorView({ points, rank }: PointsImageEditorViewProps) {
  const [imageUrl, setImageUrl] = useState<string | null>(null)

  function handleImageGenerated(imageDataUrl: string) {
    setImageUrl(imageDataUrl)
  }

  function handleDownload() {
    if (!imageUrl) return
    const a = document.createElement('a')
    a.href = imageUrl
    a.download = 'hypurr-points.png'
    document.body.appendChild(a)
    a.click()
    a.remove()
  }

  return (
    <div className="w-full">
      <div className="w-full max-w-4xl">
        <PointsImageEditor
          imageUrl="/points-download.png"
          points={points}
          rank={rank}
          onImageGenerated={handleImageGenerated}
        />
      </div>

      <div className="flex w-full flex-col items-center gap-5">
        {imageUrl ? (
          <div>
            <img src={imageUrl} alt="Generated image" className="max-w-full rounded-lg" />
            <Button className="mt-4 w-full max-w-40 text-sm" onClick={handleDownload}>
              Download PNG
            </Button>
          </div>
        ) : (
          <Skeleton className="min-h-[188px] w-full rounded-lg" />
        )}
      </div>
    </div>
  )
}
